import { Logger } from "@nolimitcity/slot-launcher/bin/utils/Logger";
import { Presentation } from "../../../../core/gameflow/controller/Presentation";
import { ReelEngineController } from "../../../../core/reel/ReelEngineController";
import { ReelEngineManager } from "../../../../core/reel/ReelEngineManager";
import { ReelState } from "../../../../core/reel/ReelEngineView";
import { SoundManager } from "../../../sound/SoundManager";
import { SoundConfig } from "../../../sound/SoundConfig";
import { PunkRocker } from "../../../PunkRocker";
import { MathHelper } from '../../../../core/utils/MathHelper';

export class StartPresentation extends Presentation {

    public static restoreStarted:boolean = false;

    protected addExtraForStart?(reel:ReelEngineController):void;

    preStart(): void {
        PunkRocker.reelEngineManager.applyMask(true);
        StartPresentation.restoreStarted = false;

        ReelEngineManager.onBeforeSpinStart();
        PunkRocker.normalIdle.onBeforeSpinStart();
        ReelEngineManager.RAll((rc: ReelEngineController) => rc.createStart({ start:() => this.addExtraForStart ? this.addExtraForStart(rc) : undefined }) );
    }

    createPresentation() {
        this.startReels();
        this.PresentationState.setInactive();
    }

    // Add Start Offset.
    protected addStartReelOffset(): boolean {
        const remaining:number = ReelEngineManager.remainingStartEngineOffset();
        this.timeline.to(this, { duration: remaining }, 0);
        return !!remaining;
    }

    startReels():void{
        let delay: number = 0;
        const startReel:number = ReelEngineManager.findReelWithState(ReelState.START,true);
        ReelEngineManager.RAll(reel => {

            if(reel.reelID == startReel) this.timeline.add( () => {SoundManager.playSoundEffect(SoundConfig.REELS_SPINNING, Number.MAX_SAFE_INTEGER,1)}, delay);

            this.timeline.add(() => reel.startReel(), delay);
            
            if(reel.isActive) delay += reel.startDelay;
        })
        // if only one reel starts, there is no time delay. Need to add some duration to trigger the elements in an gsap timeline.
        this.timeline.duration() == 0 ? this.timeline.to(this, { duration: MathHelper.frameToSeconds(1)}) : null;

    }
   
    skip(): void {
        ReelEngineManager.isQuickStop = true;
    }

    done(): void {
        Logger.logDev("Start Done");
    }
}